<template>
  <div class="personal_preview_box">
    <el-dialog   v-model="dialogVisible" title="发送预览" width="80%"  destroy-on-close :close-on-click-modal="false">
      <el-table stripe :data="tableData"  height="60vh" table-layout="fixed" :border="true">
        <el-table-column class="no-break" prop="studentCode" label="学员编码"  min-width="150px" />
        <el-table-column class="no-break" prop="studentName" label="学员姓名"  min-width="100px" />
        <el-table-column class="no-break" prop="receiveName" label="接收微信"  min-width="200px" />
        <el-table-column  class="no-break" label="发送条数" min-width='90px' >
          <template #default="scope">
            <span>{{scope.row.sendContents.length}}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="(item,index) in contentColumns" :label="item" min-width="220px">
          <template #default="scope">
              <!-- <span>{{ JSON.stringify(scope.row.sendContents[index].sendContent) }}</span> -->
              <fileCard v-if="scope.row.sendContents[index] && scope.row.sendContents[index]?.msgType != 'text'" :file-data="scope.row.sendContents[index]"></fileCard>
              <span v-else>{{ scope.row.sendContents[index]?.sendContent || scope.row.sendContents[index]?.path}}</span>
            </template>
          </el-table-column>
      </el-table>
      <template #footer>
        <div class="dialog-footer">
          <el-text class="mx-1" type="warning">共发送<span>{{studentNumber}}</span>个学员，<span>{{msgNumber}}</span>条消息，预计完成时间：{{ formatRetainTime(sendTime) }}</el-text>

          <el-button type="primary" @click="confirm">
            发送
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import fileCard from '@/components/fileCard.vue'
import { getSendTime } from '@/utils/callingAppApi'
import { computed,ref } from 'vue';
import { transformTableDataSendToApp } from '@/utils/resolveData.js'
import {formatRetainTime} from '@/utils/util'

const emit = defineEmits(['send','update:modelValue']);
const props = defineProps(['tableData','modelValue']);
const studentNumber = ref(0)
const msgNumber = ref(0);
const sendTime = ref(0);
const dialogVisible = computed({
  get: () => props.modelValue,
  set: () => emit('update:modelValue')
})

const contentColumns = computed(()=>{
  let maxContent = [];
  studentNumber.value = 0;
  msgNumber.value = 0;
  props.tableData.forEach(item=>{
    studentNumber.value++;
    msgNumber.value += item.sendContents.length;
    if(item.sendContents.length > maxContent.length){
      maxContent = item.sendContents.map((v,i)=>'群发内容'+(i+1))
    }
  })
  getSendTime(transformTableDataSendToApp(props.tableData), (res) => {
    console.log(11111,res)
    sendTime.value = res.time
  })
  return maxContent
})

// const tableData = [
//   {
//     date: '2016-05-03',
//     name: 'Tom',
//     address: 'No. 189, Grove St, Los Angeles',
//   }
// ]
const confirm = ()=>{
  emit('send')
}
</script>

<style lang="less" scoped>
.dialog-footer{
  display: flex;
  justify-content: space-between;
  
}
:deep(.el-table__cell){
    // width:100px;
    .cell{
      overflow-wrap: anywhere;
    }
  }
</style>